import axios from "axios";
import { API_BASE_URL } from "../config/config";

const ReportSmsService = {
  list: (data, signal) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      // status:data.status,
      numberpoolid: data.numberpoolid,
      isIndividual: data.isIndividual,
      startEndDate: data.startEndDate,
    });
    return axios.get(`${API_BASE_URL}/reportsms/list?${params.toString()}`, {
      signal,
    });
  },

  listDetail: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      campaignid: data.campaignid,
      numberpoolid: data.numberpoolid,
    });
    return axios.get(
      `${API_BASE_URL}/reportsms/listDetail?${params.toString()}`
    );
  },

  downloadAll: (data) => {
    const params = new URLSearchParams({
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      numberpoolid: data.numberpoolid,
      campaignid: data.campaignid,
    });
    return axios.get(
      `${API_BASE_URL}/reportsms/reportDownloadAll?${params.toString()}`
    );
  },

  campaignList: (data) => {
    return axios.post(`${API_BASE_URL}/reportsms/campaignList`, data);
  },
};

export default ReportSmsService;
